﻿
const flipbooks = document.getElementsByClassName("js-fbook");

const $ = window.$ = window.jQuery = require('jquery');
let scriptAdded = false;

loadFlipbook()


function loadFlipbook() {
    var refresh = true;

    if (window.$) {

        if (!scriptAdded) {
            scriptAdded = true;

            const head = document.getElementsByTagName('head')[0];

            const styles = document.createElement('link');
            styles.id = 'styles_flibbook_core';
            styles.rel = 'stylesheet';
            styles.type = 'text/css';
            styles.href = '/css/flipbook.min.css';
            styles.media = 'all';
            head.appendChild(styles);

            const script = document.createElement('script');
            script.id = 'script_flipbook_core';
            script.src = '/js/flipbook/flipbook.min.js';
            head.appendChild(script);
        }


        if ($.fn.flipBook) {
            refresh = false;

            $('.js-fbook').each(function () {

                const $wrap = $(this);

                $wrap.find('.js-fbook-showaltc').on('click', function (e) {
                    e.preventDefault();

                    var content = $wrap.find('.js-fbook-altc');
                    content.find(' > [class]').attr('class', '');

                    content.toggleClass('d-none');
                });


                const title = $wrap.data('fbook-title');
                const pdfUrl = $wrap.data('fbook-doc');
                const pdfUrlOpt = $wrap.data('fbook-doc-opt');
                const pdfUrlMob = $wrap.data('fbook-doc-mob');
                const skin = $wrap.data('fbook-skin');
                const bgColour = $wrap.data('fbook-bg-c');
                const bgImg = $wrap.data('fbook-bg-i');
                const singlePage = $wrap.data('fbook-single') == "1";

                const imgData = $wrap.data('fbook-images');
                const hasImages = imgData && imgData.length;

                var settings = {
                    name: title,
                    sound: false,
                    flipSound: false,
                    layout: "1",
                    mobile: {
                        btnPrint: { enabled: false },
                        btnDownloadPages: { enabled: false }
                    },
                    btnExpand: {
                        hAlign: "left"
                    },
                    btnSound: {
                        enabled: false
                    },
                    btnSelect: {
                        enabled: !hasImages
                    },
                    backgroundImage: "",
                    backgroundTransparent: true
                }

                if (hasImages) {
                    settings.pages = imgData;
                }

                if (pdfUrl) {
                    if (!hasImages) {
                        settings.pdfUrl = pdfUrlOpt ? pdfUrlOpt : pdfUrl; // Set an optimised version if it exists

                        if (pdfUrlMob) {
                            // Add a mobile specific version
                            settings.mobile = settings.mobile || {};
                            settings.mobile.pdfUrl = pdfUrlMob;
                        }
                    }
                    settings.btnDownloadPdf = {
                        url: pdfUrl
                    }
                }

                if (skin) {
                    settings.skin = skin;
                }
                if (bgColour) {
                    settings.backgroundColor = bgColour;
                }
                if (bgImg) {
                    settings.backgroundPattern = bgImg;
                }
                if (singlePage) {
                    settings.singlePageMode = true;
                }


                // Load the flipbook
                const $book = $wrap.find('.js-fbook-book');
                $book.html('');
                $book.flipBook(settings);

            });
        }
    }

    if (refresh) {
        setTimeout(function () { loadFlipbook(); }, 50);
    }
}

